const ALPHABET = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'

/** Same shape the server generates, so optimistic rows need no id remapping. */
export function itemId(): string {
  const bytes = new Uint8Array(12)
  crypto.getRandomValues(bytes)
  let out = ''
  for (const byte of bytes) out += ALPHABET[byte % ALPHABET.length]
  return out
}

export function opId(): string {
  return crypto.randomUUID()
}

const CLIENT_KEY = 'streepaf.clientId'

/** Identifies this tab so it can ignore the echo of its own changes. */
export function clientId(): string {
  try {
    const existing = sessionStorage.getItem(CLIENT_KEY)
    if (existing) return existing
    const fresh = crypto.randomUUID()
    sessionStorage.setItem(CLIENT_KEY, fresh)
    return fresh
  } catch {
    return crypto.randomUUID()
  }
}
